import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, PropType } from 'vue';

import SdsSection14Form from '@/views/dashboard/sdsDrawer/forms/SdsSection14Form.vue';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection14',
  props: {
  unNumber: {
    type: String,
    required: true,
  },
  unNumberList: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:isValid", "update:unNumber", "update:unNumberList"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:unNumber', data: string): void;
  (e: 'update:unNumberList', data: Array<string>): void;
}), expose: any, slots: any, attrs: any }) {



const form = ref<InstanceType<typeof VForm> | null>(null);
const isValid = ref<boolean>(false);



const updateUnNumber = (e: string) => {
  emits('update:unNumber', e);
};

const updateUnNumberList = (e: Array<string>) => {
  emits('update:unNumberList', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,form, isValid, emits, updateUnNumber, updateUnNumberList, SdsSection14Form, sharedMessages }
}

})